import { Button, Dialog } from "@app/ui";
import { useI18n } from "../../lib/useI18n.js";
import { useThemeConflictStore } from "./theme-sync.js";

/** Prompt shown when this device and another have divergent themes (theme sync
 *  conflict). "Keep" remembers the choice until the synced theme changes again;
 *  closing/dismissing defaults to keep (non-destructive). Shell-mounted. */
export function ThemeConflictDialog() {
  const { t } = useI18n();
  const pending = useThemeConflictStore((s) => s.pending);
  const override = useThemeConflictStore((s) => s.override);
  const keep = useThemeConflictStore((s) => s.keep);

  return (
    <Dialog open={!!pending} onClose={() => void keep()} title={t("theme.conflict.title")} className="max-w-md">
      <div className="flex flex-col gap-4">
        <p className="text-sm text-foreground">{t("theme.conflict.body")}</p>
        <div className="flex flex-col gap-2">
          <Button onClick={() => void override()}>{t("theme.conflict.override")}</Button>
          <Button variant="ghost" onClick={() => void keep()}>{t("theme.conflict.keep")}</Button>
        </div>
      </div>
    </Dialog>
  );
}
